import React, { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Copy, Check, ExternalLink } from "lucide-react";

export default function TriggerAppSection({ trigger }) {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);
    const appUrl = `${window.location.origin}/public/${trigger.publicKey}`;

    const handleCopy = useCallback(() => {
        navigator.clipboard.writeText(appUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    }, [appUrl]);

    const handleOpen = useCallback(() => {
        window.open(appUrl, "_blank", "noopener,noreferrer");
    }, [appUrl]);

    return (
        <div className="p-4 space-y-4">
            <div>
                <label className="text-xs font-medium text-gray-700 block mb-1">{t("chatInput.appUrl")}</label>
                <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-lg p-2">
                    <ExternalLink size={14} className="text-gray-400 flex-shrink-0" />
                    <code className="text-xs text-gray-700 break-all flex-1">{appUrl}</code>
                    <button onClick={handleCopy} className="p-1 hover:bg-gray-200 rounded flex-shrink-0">
                        {copied ? <Check size={14} className="text-green-500" /> : <Copy size={14} className="text-gray-400" />}
                    </button>
                </div>
            </div>
            <button
                onClick={handleOpen}
                className="w-full flex items-center justify-center gap-2 px-3 py-2 text-xs font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 transition-colors"
            >
                <ExternalLink size={12} />
                {t("chatInput.openApp")}
            </button>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <p className="text-xs text-blue-700">
                    {t("chatInput.appTriggerHelp")}
                </p>
            </div>
        </div>
    );
}
